import Form from "react-bootstrap/Form";

const styles = {
  input: {
    fontSize: "clamp(1rem, 2rem, 2vh)",
    fontWeight: 500,
    borderRadius: "6rem",
    outline: "none",
    padding: "1rem 2rem",
    height: "auto",
  },
  label: {
    fontWeight: 500,
    fontSize: "clamp(1.5rem, 3rem, 2vh)",
  },
  error: {
    fontSize: "clamp(1rem, 2rem, 2vh)",
  },
};

function InputForm({
  id,
  label,
  placeholder,
  value,
  onChange,
  type = "text",
  error,
}) {

  return (
    <Form.Group className="mb-3" controlId={id}>
      <Form.Label style={styles.label}>{label}</Form.Label>
      <Form.Control
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={styles.input}
        isInvalid={!!error}
      />
      {error && (
        <Form.Control.Feedback style={styles.error} type="invalid">
          {error}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
}
export default InputForm;